export const URL_FATURAS = "https://faturas.cob.cloud";
